module.exports = __webpack_public_path__ + "img/icon_newplus.521ace27.svg";